import {Base} from "@/api/Base"

export class PlanCategoryListAll extends Base {
    path = "planCategory/listAll"
}